// AWARD GRT
export const POST_AWARD_GRT = 'POST_AWARD_GRT';
export const POST_AWARD_GRT_SUCCESS = 'POST_AWARD_GRT_SUCCESS';
export const POST_AWARD_GRT_FAILURE = 'POST_AWARD_GRT_FAILURE';

